import { GetMetadataByTrialCode, GetMetadataResponse } from '@/api/dtos';
import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';

const getData = (response?: SWRResponse<GetMetadataResponse, GetMetadataResponse>) => response?.data?.metadata;
const getError = (response?: SWRResponse<GetMetadataResponse, GetMetadataResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useMetadata = (trialCode: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return trialCode ? 
            () => new GetMetadataByTrialCode({ trialCode }) : 
            undefined;
    }, [trialCode]);

    return useGet(request, { getData, getError}, configuration);
};

export default useMetadata;